/**
 * Event Countdown Timer
 */

export function initCountdown(): void {
  const containers = document.querySelectorAll<HTMLElement>('[data-countdown]');

  containers.forEach((countdown) => {
    const dateAttr = countdown.getAttribute('data-countdown');
    if (!dateAttr) return;

    const eventDate = new Date(dateAttr).getTime();

    function update(): void {
      const now = Date.now();
      const distance = eventDate - now;

      if (distance < 0) {
        countdown.style.display = 'none';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      const daysEl = countdown.querySelector<HTMLElement>('[data-days]');
      const hoursEl = countdown.querySelector<HTMLElement>('[data-hours]');
      const minutesEl = countdown.querySelector<HTMLElement>('[data-minutes]');

      if (daysEl) daysEl.textContent = String(days);
      if (hoursEl) hoursEl.textContent = String(hours);
      if (minutesEl) minutesEl.textContent = String(minutes);
    }

    update();
    setInterval(update, 60000);
  });
}
